import _typeof from "@babel/runtime/helpers/typeof";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
/**
  * @module list-normalizer
  */

/**
 * @typedef {function} ComponentWithTransformedList - a new component which can transform list (defined by *listPropName*) according to config (defined by *transformPropName*)
 * @property {array.<object>} [*listPropName*] - list to apply transformation to
 * @property {object} [*transformPropName*] - key/value pair, key=name to pass onto Component, value=name to take
 */

/**
 * Normalize list in Component
 * @param {component} Component - which component to apply transformation to?
 * @param {string} [listPropName='list'] - name of the Component prop which will be the target to apply transformation to
 * @param {string} [transformPropName='listTransform'] - name of the transformation config
 * @return {ComponentWithTransformedList} transformd component
 *
 * @example
// See [example]{@link https://git.gorilla-technology.com/gorilla/react-ui/blob/master/examples/src/form.js}
 */

export default function normalizeList(NormalizeListComponent) {
  var _objectSpread2;

  var listPropName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'list';
  var transformPropName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'listTransform';
  var ResultComponent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var transformCfg = _ref[transformPropName],
        listToTransform = _ref[listPropName],
        props = _objectWithoutProperties(_ref, [transformPropName, listPropName].map(_toPropertyKey));

    return /*#__PURE__*/React.createElement(NormalizeListComponent, _extends({
      ref: ref
    }, props, _defineProperty({}, listPropName, !transformCfg ? listToTransform : _.map(listToTransform, function (item) {
      return _.mapKeys(item, function (v, k) {
        return _.get(_.invert(transformCfg), k);
      });
    }))));
  });
  ResultComponent.propTypes = _objectSpread(_objectSpread({}, NormalizeListComponent.propTypes || {}), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, transformPropName, PropTypes.object), _defineProperty(_objectSpread2, listPropName, PropTypes.array), _objectSpread2));
  return ResultComponent;
}